module.exports = __webpack_public_path__ + "img/stp_url_blue.57beeb55.svg";